import { Link } from 'react-router-dom'
import { useModals } from '../contexts/ModalContext.jsx'
import { IconSparkle } from './Icons.jsx'
import { INTAKE_PATH } from '../pages/home/constants/links.js'

export function CtaStrip({
  title = 'Ready to feel like yourself again?',
  subtitle = 'Start a free visit with a licensed HealBerry provider — no card required.',
}) {
  const { openBarry } = useModals()

  return (
    <section className="bg-teal-600 py-20 text-center text-white max-[640px]:py-14">
      <div className="hb-wrap">
        <div className="mx-auto max-w-[720px]">
          <h2 className="font-serif text-[clamp(28px,4vw,44px)] font-semibold tracking-[-0.5px] text-white">
            {title}
          </h2>
          <p className="mx-auto mt-3 max-w-[520px] text-[18px] text-white max-[640px]:text-[15px]">
            {subtitle}
          </p>
          <div className="mt-[30px] flex flex-wrap items-center justify-center gap-3.5 max-[640px]:mt-5">
            <Link to={INTAKE_PATH} className="btn btn-white btn-lg">
              Start my free visit
            </Link>
            <button type="button" onClick={openBarry} className="btn btn-ghost-white btn-lg">
              <IconSparkle /> Find my treatment
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
